export const Pages = {
  '/': 'home',
  '/resume-templates': 'templates_resume',
  '/cover-letter-templates': 'templates_cover_letter',
  '/resume-examples': 'examples_resume_index',
  '/resume-examples/*': 'examples_resume_show',
  '/cover-letter-examples': 'examples_cover_letter_index',
  '/cover-letter-examples/*': 'examples_cover_letter_show',
  '/blog': 'posts',
  '/build-resume': 'builder',
  '/europass-cv': 'europass',
  '/ai-resume-builder': 'ai_builder',
  '/contact': 'faq',
  '/about': 'about',
}

export const getPageLabel = path => {
  // First try exact match
  if (Pages[path]) {
    return Pages[path]
  }

  // Then try with trailing slash
  const pathWithSlash = path.endsWith('/') ? path : `${path}/`
  if (Pages[pathWithSlash]) {
    return Pages[pathWithSlash]
  }

  // Handle sub-paths for main sections
  const mainSections = {
    '/resume-templates': 'templates_resume',
    '/cover-letter-templates': 'templates_cover_letter',
    '/resume-examples': 'examples_resume_show',
    '/cover-letter-examples': 'examples_cover_letter_show',
    '/blog': 'posts',
  }

  for (const [section, label] of Object.entries(mainSections)) {
    if (path.startsWith(section)) {
      return label
    }
  }

  return path
}
